// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1zzoJzpB9xz53rZwmdTAK2"};